import React from "react";
import { MainLayout } from "src/apps/commons/layouts";
import { Dashboard } from "../apps/modules/dashboard";

const Page = () => <Dashboard />;
Page.Layout = MainLayout;

export default Page;
